module.exports = __webpack_public_path__ + "static/media/298312.62ac6642.png";